import React from 'react'

const ProjectHeader = () => {
    return (
        <header>
            <div className='h-[100px]'></div>
            <h1 className='text-orange-400 text-7xl max-md:text-5xl'>
                Hi! Welcome to <br /> my projects page.
            </h1>
            <h3 className='text-black text-xl mt-3 max-md:text-lg'>Each project was made with passion, love and caffeine!</h3>
        </header >
    )
}

export default ProjectHeader
